// Delegated outbound link tracking for Microsoft Clarity

document.addEventListener('click', function (event) {
  var link = event.target.closest('a');
  if (!link || !link.href) return;

  var currentHost = window.location.hostname;
  try {
    var url = new URL(link.href, window.location.href);
    if (url.hostname && url.hostname !== currentHost) {
      if (typeof clarity === 'function') {
        clarity('track', 'Custom Outbound Click', { url: link.href });
      }
    }
  } catch (err) {
    // ignore invalid URLs
  }
});

(function () {
  let lastHiddenTime = null;
  let returnedAfterDelay = false;

  // Track when the page becomes hidden or visible
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      lastHiddenTime = Date.now();
    } else if (document.visibilityState === 'visible') {
      if (lastHiddenTime && (Date.now() - lastHiddenTime) > 60000) {
        // User was away for more than 60 seconds and then returned
        returnedAfterDelay = true;
      }
      lastHiddenTime = null;
    }
  });

  // When the user navigates away again, send the custom event to Clarity
  window.addEventListener('beforeunload', () => {
    if (returnedAfterDelay) {
      clarity('event', 'possible_price_checker', {
        productId: window.productId // replace with your logic to pass the product ID
      });
    }
  });
})();